import CardStockDetailNew from "../../../components/screen/inventory/CardStock/CardStockDetailNew";
import HOC from "../../../components/HOC";
import PageTemplateNew from "../../../components/common/particles.jsx/PageTemplateNew";
import BreadcrumbCardstock from "../../../components/screen/inventory/CardStock/BreadcrumbCardstock";

const CardStockDetailNewPage = ({ isWarehouse }) => {
  return (
    <div className="">
      <PageTemplateNew
        header={"Detail Kartu Stok " + (isWarehouse ? "Central Warehouse" : "")}
        mainComponent={<CardStockDetailNew isWarehouse={isWarehouse} />}
        pageRole={isWarehouse ? 30 : 24}
        breadcrumb={
          <BreadcrumbCardstock
            isWarehouse={isWarehouse ? isWarehouse : false}
          />
        }
      />
    </div>
  );
};

export default HOC(CardStockDetailNewPage);
